export default [
  {
    field: 'col-opt',
    title: '操作',
    align: 'center',
    width: 170,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'isLineFee',
    align: 'center',
    minWidth: 150,
    title: '是否与线路有关',
  },
  {
    field: 'feeName',
    align: 'center',
    minWidth: 150,
    title: '费用类型',
  },

  {
    field: 'priceType',
    align: 'center',
    minWidth: 80,
    title: '计费方式',
  },

  {
    field: 'chargeUnit',
    align: 'center',
    minWidth: 100,
    title: '计费单位',
  },
  {
    field: 'feeRemark',
    align: 'center',
    minWidth: 100,
    title: '备注',
  },

  {
    field: '',
    align: 'center',
    minWidth: 90,
    title: '始发地',
  },
  {
    field: '',
    align: 'center',
    minWidth: 90,
    title: '目的地',
  },
  {
    field: '',
    align: 'center',
    minWidth: 90,
    title: '失效',
  },
  {
    field: '',
    align: 'center',
    minWidth: 100,
    title: '价格信息',
  },
]
